import { Alignment } from "../alignment"
import { SortDirection } from "../sortDirection"

export interface InsightFormattingOptions {
	calculationTable?: CalculationTableFormattingOptions
}

export interface CalculationTableFormattingOptions {
	/* Headings */
	headingsAlignment: Alignment
	columnsSort: SortDirection | null,
	verticalHeadings: boolean

	/* Result rows */
	valuesAlignment: Alignment
	displayUserHeaderFields: boolean
	excludeUserHeaderFields: string[]
}

export const createDefaultInsightFormattingOptions: () => InsightFormattingOptions = () => {
	return {}
}

export const createDefaultCalculationTableFormattingOptions: () => CalculationTableFormattingOptions = () => {
	return {
		/* Headings */
		headingsAlignment: Alignment.Left,
		columnsSort: null,
		verticalHeadings: false,

		/* Result rows */
		valuesAlignment: Alignment.Left,
		displayUserHeaderFields: true,
		excludeUserHeaderFields: []
	}
}
